import React from "react";

//Components
import Logo from "../logo/logo";

const ContentImage = ({ heroData, children }) => {
	const { image, title, logo } = heroData;

	return (
		<div className="hero">
			<div className="shell">
				<div className="hero__inner">
					<div className="hero__image">
						<img src={image} alt="" />
					</div>

					<div className="hero__content">
						<Logo img={logo} />

						<h1>{title}</h1>

						{children}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ContentImage;
